<template>
  <div class="vHeader" :style="'background-color:'+bgColor">
    <i class="backIcon backIcon1" @click="comBack" v-if="bgIcon"></i>
    <i class="backIcon backIcon2" @click="comBack" v-else></i>
    <h1 class="titleName">{{ title }}</h1>
  </div>
</template>

<script>
export default {
  name: 'Header',
  data () {
    return {
      title: '',
      bgColor: '#fff',
      bgIcon: true
    }
  },
  watch: {
    $route: {
      handler (val, oldVal) {
        this.init();
      },
      deep: true
    }
  },
  created () {
    this.init();
  },
  mounted () {

  },
  methods: {
    init () {
      let _show = this.$route.meta.show || false;
      let timer = null;
      this.title = this.$route.meta.title || '';
      this.bgColor = this.$route.meta.bgColor || '#fff';
      console.log(_show)
      if( _show ){
        if( this.$route.meta.bgColor=='transparent' ){
          this.bgIcon = false;
          return
        }
        if( !this.title ){
          let _num = 0;
          timer = setInterval(()=>{
            if( this.title ){
              clearInterval(timer);
              return;
            }
            if( _num>=20 ){
              clearInterval(timer);
              this.title = '大方租车';
              return;
            }
            _num ++;
            this.title = this.$route.meta.title || '';
          }, 100)
        }
      }
    },
    comBack () {
      console.log('需要调用安卓原生返回方法');
      let backName = this.$route.meta.back;
      if (backName) {
        this.$router.replace({name: backName});
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.vHeader {
  width: 100%;
  height: 110px;
  line-height: 110px;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1;
  .backIcon1 { background-image: url("~@/assets/images/backIcon.png"); }
  .backIcon2 { background-image: url("~@/assets/images/backIcon2.png"); }
  .backIcon {
    display: block;
    width: 40px;
    height: 40px;
    position: absolute;
    top: 35px;
    left: 35px;
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
  }
  .titleName {
    width: 100%;
    font-size: 32px;
    text-align: center;
    font-weight: normal;
  }
}
</style>
